export const Utils = window.utilsServiceModule.Utils;